// Agency info
export const AGENCY_CODE = "FORAVILA";
export const AGENCY_NAME = "Foravila Rentals";
export const AGENCY_WEBSITE = "https://www.foravilarentals.com";
export const AGENCY_GUESTS_INTRANET_LOGIN =
  "https://guests.foravilarentals.com/login";

// TPV config
export const TPV_BASE_LINK = "https://tpv.foravilarentals.com";
